import { Divider } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import ETipoDocumentoOnboarding from 'modules/pagamentos/domain/entities/ETipoDocumentoOnboarding'
import TipoEmpresa from 'modules/pagamentos/domain/entities/TipoEmpresa'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import React, { FunctionComponent, useState } from 'react'
import SnackBar from 'shared/components/SnackBar'
import Footer from '../components/Footer'
import LTDA from '../components/LTDA'
import SA from '../components/SA'
import { Subtitle, Title } from '../styles'

const Documentos: FunctionComponent = () => {
  const { frotista } = useFrotista()
  const {
    handleNextButton,
    handleBackButton,
    getDocumentoNome,
    removeDocumentoRepresentantes,
    removeDocumentosEmpresa,
  } = useOnboarding()
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const tipoEmpresa = new TipoEmpresa()

  const isMei = tipoEmpresa.isMEI(frotista.natureza_juridica)
  const isSA = tipoEmpresa.isSA(frotista.natureza_juridica)

  const handleSubmitSA = () => {
    setOpenErrorMessage(false)

    if (
      !getDocumentoNome(ETipoDocumentoOnboarding.ESTATUTO_SOCIAL) ||
      !getDocumentoNome(ETipoDocumentoOnboarding.CONTRATO_SOCIAL) ||
      !getDocumentoNome(
        ETipoDocumentoOnboarding.DECLARACAO_BENEFICIARIOS_FINAIS,
      )
    ) {
      setErrorMessage(
        'Anexar Estatuto da empresa, Contrato Social e Declaração dos beneficiários finais',
      )
      setOpenErrorMessage(true)
    } else {
      handleNextButton()
    }
  }

  const handleSubmit = () => {
    setOpenErrorMessage(false)

    if (!getDocumentoNome(ETipoDocumentoOnboarding.CONTRATO_SOCIAL)) {
      setErrorMessage('Anexar Contrato Social')
      setOpenErrorMessage(true)
    } else {
      handleNextButton()
    }
  }

  const handleGoBack = () => {
    // removeDocumentoRepresentantes()
    handleBackButton()
  }

  if (isSA)
    return (
      <>
        <Divider style={{ margin: '32px 0' }} />
        <Grid container>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Title>Dados da empresa</Title>
            <Subtitle>
              Informe os dados da empresa e os contatos empresariais.
            </Subtitle>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <SA />
          </Grid>
        </Grid>
        <Grid container>
          <Footer
            onClickBackButton={handleGoBack}
            onClickNextButton={handleSubmitSA}
            titleNextButton="Próximo"
            titleBackButton="Voltar"
          />
        </Grid>
      </>
    )

  if (isMei) {
    removeDocumentosEmpresa()
    handleNextButton()
  }

  return (
    <>
      <Divider style={{ margin: '32px 0' }} />
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Title>Dados da empresa</Title>
          <Subtitle>
            Informe os dados da empresa e os contatos empresariais.
          </Subtitle>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <LTDA />
        </Grid>
      </Grid>
      <Grid container>
        <Footer
          onClickBackButton={handleGoBack}
          onClickNextButton={handleSubmit}
          titleNextButton="Próximo"
          titleBackButton="Voltar"
        />
      </Grid>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default Documentos
